// these start with numbers to order them
const HAZARD_TYPE_CRITICAL = '1_critical';
const HAZARD_TYPE_OTHER = '10_other';
const HAZARD_TYPE_STANDARD = '99_standard';
/**
 * DO NOT, UNDER ANY CIRCUMSTANCES
 * REPLACE SOMETHING IN THIS LIST.
 * DELETE AND ADD TO BOTTOM ONLY.
 */
const genericHazards = {
  hazard1: {
    risk: '<b>Infectious Diseases</b><br/>Risk: being infected by virus present on surfaces and/or person(s) on site.',
    mitigations: '<ul><li>Access control and contact tracking and tracing </li><li>Physical distance (2m if poss. or 1m min. for staff).</li><li>Regular cleaning, personal hygiene, PPE (gloves, facemasks)</li><li>Site containment procedures</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard2: {
    risk: '<b>Moving vehicles on site</b><br/>Risk: pedestrians being struck by moving plant and vehicles.',
    mitigations: '<ul><li>Traffic plans on site and exclusion zones </li><li>Wearing PPE and flashing lights on machinery (visibility)</li><li>Eye contact/observational awareness</li><li>Trained operators</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard3: {
    risk: '<b>Uneven, sloping ground</b><br/>Risk: machine roll-overs when operating on sloping / uneven ground.',
    mitigations: '<ul><li>Assessment of work area before undertaking work to create workable plan</li><li>Operational plans e.g. “maintaining 1 metre gap from high risk areas”</li><li>Methodology; working along slope, not up down slope</li><li>Trained operators</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard4: {
    risk: '<b>Live above/underground services</b><br/>Risk: striking buried live services or power lines.',
    mitigations: '<ul><li>Check locations before digging / operating (review plans, B4UDig, service locate)</li><li>Contact local authorities and use a stand-over where necessary </li><li>Pothole before digging if in doubt</li><li>Review JSEAs</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard5: {
    risk: '<b>Working around live traffic</b><br/>Risk: being struck by traffic when working in live traffic environments.',
    mitigations: '<ul><li>Traffic segregation plans</li><li>Traffic exclusion zones</li><li>Signage</li><li>PPE</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard6: {
    risk: '<b>Unstable earth banks / soil faces</b><br/>Risk: trapped under collapsed soil (trenching, excavating retaining walls).',
    mitigations: '<ul><li>Trench shields</li><li>Using effective bench and batters</li><li>Exclusion zones</li><li>Physical barriers</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard7: {
    risk: '<b>Stressful working conditions</b><br/>Risk: staff illness, stress, fatigue due to a “we’ll be right” culture.',
    mitigations: '<ul><li>Taking appropriate breaks</li><li>Managing workloads</li><li>Looking out for each other.</li><li>EAP services</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard8: {
    risk: '<b>Driving on/near public roads</b><br/>Risk: vehicle accidents while travelling to and from job sites.',
    mitigations: '<ul><li>Fully licenced and trained drivers/operators</li><li>Driving defensively</li><li>Safe vehicles (as per vehicle policy)</li><li>Seat belts worn always</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard9: {
    risk: '<b>Working at height</b><br/>Risk: falling from height (e.g. exiting machines or working on stockpiles).',
    mitigations: '<ul><li>Plan your work and methodology to eliminate the risk if possible</li><li>Create exclusion zones and physical barriers</li><li>Seat belts worn always</li><li>Maintain 3 points of contact</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard10: {
    risk: '<b>Falling objects</b><br/>Risk: being struck by objects if working in trenches, below stockpiles / diggers',
    mitigations: '<ul><li>Exclusion zones</li><li>Drop valves (on hydraulics)</li><li>ROPs</li><li>PPE</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard11: {
    risk: '<b>Working with power/hand tools</b><br/>Risk: loss of control of tools causing injury (e.g. concrete saws).',
    mitigations: '<ul><li>Guarding and safety zones</li><li>Trained and competent users</li><li>Equipment pre-checks</li><li>PPE</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard12: {
    risk: '<b>Working with Chemicals</b><br/>Risk: exposure to fumes when working in confined spaces.',
    mitigations: '<ul><li>Check safety data sheets (SDS)</li><li>Confined spaces training</li><li>Gas Detector </li><li>PPE</li></ul>',
    type: HAZARD_TYPE_CRITICAL,
  },
  hazard13: {
    risk: '<b>Heavy objects</b><br/>Risk: strains and sprains due to incorrectly lifting and handling.',
    mitigations: '<ul><li>Don’t man-handle heavy items. Ask for help!</li><li>Bend your knees when lifting</li><li>Lift with a machine and where possible keep the load close to the ground</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard14: {
    risk: '<b>Uneven ground and obstacles</b><br/>Risk: slips, trips, falls, sprains (includes when moving on and off machinery)',
    mitigations: '<ul><li>Maintain 3 points of contact when climbing in and out of machinery/plant</li><li>Watch footing on uneven ground (wear appropriate well-supported footwear)</li><li>Keep site clean and tidy and free from trip hazards</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard15: {
    risk: '<b>Sharp and protruding objects</b><br/>Risk: cuts and bruises while handling materials, small plant and other items.',
    mitigations: '<ul><li>Wear appropriate PPE (gloves, protective clothing)</li><li>Use the correct equipment where appropriate</li><li>Don’t man-handle items unnecessarily</li></ul>',
  },
  hazard16: {
    risk: '<b>Dust</b><br/>Risk: Eye irritations and irritation to breathing.',
    mitigations: '<ul><li>Keep dust down with regular water spraying</li><li>Use the correct equipment where appropriate to reduce dust</li><li>Wear appropriate PPE (eye wear, face masks)</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard17: {
    risk: '<b>Noise</b><br/>Risk: hearing loss due to exposure to loud power tools / machinery',
    mitigations: '<ul><li>Wear appropriate hearing protection</li><li>Exclusion zones / keep a safe distance from noise</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard18: {
    risk: '<b>Unfamiliar environment</b><br/>Risk: general injuries to staff, visitor and public who are unfamiliar with site',
    mitigations: '<ul><li>Perimeter needs to be marked with safety tape / safety netting / fenced off</li><li>All visitors required to report to site office / supervisor / site contact</li><li>First Aid Kit and Fire Extinguisher in every vehicle (with exception of open cab vehicles)</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard19: {
    risk: '<b>Hazardous substances</b><br/>Risk: exposure to fuels, oils, paints and solvents causing burns, poisoning, or respiratory issues.',
    mitigations: '<ul><li>Correct storage and labelling</li><li>Spill kits available</li><li>PPE (gloves, goggles, respirators)</li><li>SDS access; good ventilation.</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard20: {
    risk: '<b>Fire & explosion</b><br/>Risk: burns or serious injury from welding, grinding, or flammable liquids igniting.',
    mitigations: '<ul><li>Hot work permits</li><li>Fire extinguishers on hand</li><li>Fire watch assigned</li><li>No ignition sources near fuels</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard21: {
    risk: '<b>Manual handling / lifting</b><br/>Risk: strains, sprains, or crush injuries from lifting engines, drums, or heavy parts incorrectly.',
    mitigations: '<ul><li>Use lifting equipment or mechanical aids</li><li>Apply correct lifting technique</li><li>Perform team lifts where needed</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard22: {
    risk: '<b>Electrical hazards</b><br/>Risk: electrocution or burns from faulty welding gear, power tools, or uninspected equipment.',
    mitigations: '<ul><li>Lockout/Tagout</li><li>Use insulated tools</li><li>Ensure regular inspections and testing</li><li>Competent operators only</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard23: {
    risk: '<b>Compressed gases</b><br/>Risk: explosion, asphyxiation, or fire from oxy-acetylene or other stored gases.',
    mitigations: '<ul><li>Store in secure cages</li><li>Keep cylinders upright</li><li>Ensure handling training</li><li>Use correct PPE</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard24: {
    risk: '<b>Emergency situations</b><br/>Risk: injury or loss from uncontrolled fire, chemical spill, or medical emergency without effective response.',
    mitigations: '<ul><li>Clear emergency procedures</li><li>Conduct regular drills</li><li>Alarms functional</li><li>First aiders available</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
  hazard25: {
    risk: '<b>Heavy machinery operation</b><br/>Risk: collision, rollover, or crush injuries from operating excavators, loaders, forklifts or trucks unsafely.',
    mitigations: '<ul><li>Competency checks</li><li>Pre-start inspections</li><li>PPE (high-vis, steel-toe boots)</li><li>Seatbelts</li><li>Speed limits</li><li>Spotters when required</li></ul>',
    type: HAZARD_TYPE_STANDARD,
  },
};

const workSafeTasks = [
  '<b>Work in Trench</b><br/>Work in any pit, shaft, trench, or other excavation more than 1.5 metres deep and a depth greater than the horizontal width at the top.',
  '<b>Work at Height</b><br/>Construction work with a risk of falling 5 metres or more (see Worksafe site for exclusions)',
  '<b>Working on Vertical Face</b><br/>Work in any excavation with a vertical face height &gt; 5 metres and an average slope steeper than a ratio of 1 (horizontal) to 2 (vertical).',
  '<b>Scaffolding</b><br/>Erecting or dismantling scaffolding with a risk of falling 5 metres or more.',
  '<b>Tree Felling</b><br/>Logging or tree felling undertaken for commercial purposes',
  '<b>Heavy Lifting</b><br/>Use of a lifting appliance to lift &gt; 500kg a height of &gt; 5 metres (excludes using an excavator, forklift, or self-propelled mobile crane)',
  '<b>Use of Explosives</b><br/>Work involving the use of explosives, or storage of explosives for use at the worksite',
  '<b>Underground Works</b><br/>Work in any drive, excavation, or heading in which any person is required to work with a ground cover overhead',
  '<b>Use of Respirator</b><br/>Work in which a person breathes compressed air, or a respiratory medium other than air (diving and not diving)',
  '<b>Licensed asbestos removal</b><br/>The safe elimination of asbestos-containing materials by certified professionals.',
];

const ppe = [
  { icon: 'Vest', name: 'Hi-Viz' },
  { icon: 'Boots', name: 'Steel capped boots' },
  { icon: 'Longs', name: 'Long Clothing' },
  { icon: 'Hardhat', name: 'Hard Hat' },
  { icon: 'Gloves', name: 'Gloves' },
  { icon: 'Glasses', name: 'Eye Protection' },
  { icon: 'Mask', name: 'Face Masks' },
  { icon: 'Earmuffs', name: 'Ear Protection' },
];

/**
 * We store them in short form in the DB
 * So when we're listing sites, it's not MB and MBs of data
 */
const mapHazards = (hazards) => hazards.map((hazard) => {
  const genericHazard = genericHazards[hazard.risk];
  if (genericHazard) {
    hazard.risk = genericHazard.risk; // eslint-disable-line no-param-reassign
    hazard.mitigations = genericHazard.mitigations; // eslint-disable-line no-param-reassign
    hazard.type = genericHazard.type; // eslint-disable-line no-param-reassign
  }
  return hazard;
});

const formatPhoneList = (phoneList) => {
  if (!phoneList || phoneList.length === 0) return [];

  return phoneList.split('\n')
    .map((line) => line.split('&#40;'))
    .map(([rawName, rawNum = '']) => ({ name: rawName.trim(), phone: rawNum.replace(/\D/g, '') }))
    .filter((item) => item.name.length > 0);
};

const formatHazard = (raw) => {
  const hazard = { ...raw };
  if (hazard.risk.indexOf('<b>') !== 0) hazard.risk = `<b>${hazard.risk}</b>`; // eslint-disable-line no-param-reassign
  hazard.risk = hazard.risk.replace('&nbsp;&nbsp;', '').replace('\\', ''); // eslint-disable-line no-param-reassign
  hazard.accepted = false;
  return hazard;
};

const formatOtherHazard = (raw) => {
  const hazard = { ...raw };
  if (hazard.risk.indexOf('<b>') !== 0) hazard.risk = `<b>${hazard.risk}</b>`; // eslint-disable-line no-param-reassign
  hazard.risk = hazard.risk.replace('&nbsp;&nbsp;', '').replace('\\', ''); // eslint-disable-line no-param-reassign
  if (hazard.mitigations) {
    hazard.risk = `${hazard.risk}<br/>Risk: ${hazard.mitigations}`;
  }
  hazard.accepted = false;
  return hazard;
};

const emailAddressTranslation = (emailAddress) => (emailAddress ? emailAddress
  .substr(0, emailAddress.indexOf('@'))
  .replace(/\./g, ' ')
  .replace(/\b[a-z]/g, (letter) => letter.toUpperCase()) : '');

const formatSite = (rawSite, accepted = false) => {
  const site = { ...rawSite };

  if (site.ownerUsername) {
    site.ownerName = emailAddressTranslation(site.ownerUsername);
  }

  if (site.forepersonUsername) {
    site.forepersonName = emailAddressTranslation(site.forepersonUsername);
  }

  site.criticalRisks = mapHazards(site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_CRITICAL).map(formatHazard);
  site.additionalRisks = mapHazards(site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_OTHER).map(formatOtherHazard);
  site.allCriticalRisks = [...site.criticalRisks, ...site.additionalRisks];

  site.standardRisks = mapHazards(site.hazards || []).filter((hazard) => hazard.type === HAZARD_TYPE_STANDARD).map(formatHazard);

  // If there are no critical risks
  if (site.criticalRisks.length === 0) {
    site.criticalRisks = [{ risk: 'There are NO critical site hazards on site.', accepted }];
  }

  // If there are no additional risks
  if (site.additionalRisks.length === 0) {
    site.additionalRisks = [{ risk: 'There are NO additional site hazards on site.', accepted }];
  }

  // If there are no standard risks
  if (site.standardRisks.length === 0) {
    site.standardRisks = [{ risk: 'There are NO general site hazards on site.', accepted }];
  }

  // WorkSafe Tasks
  if (site.tasks && site.tasks.length > 0) {
    site.tasks = site.tasks.map((task) => ({ text: task, accepted }));
  } else {
    site.tasks = [{ text: 'There are NO WorkSafe notifiable tasks on site today.', accepted }];
  }

  if (site.ppe && site.ppe.length > 0) {
    site.ppe = site.ppe.map((ppeItem) => ({ title: ppeItem, accepted }));
  } else {
    // Should not be possible to get here but just in case...
    site.ppe = [{ title: 'No PPE required on site', accepted }];
  }

  // safety
  site.safety = [];

  if (site.firstAiders) {
    site.safety.push({
      title: 'First Aiders on Site',
      phoneList: formatPhoneList(site.firstAiders),
      accepted,
    });
  }

  if (site.emergencyWardens) {
    site.safety.push({
      title: 'Emergency Wardens on Site',
      phoneList: formatPhoneList(site.emergencyWardens),
      accepted,
    });
  }

  if (site.evacuationPoints) {
    site.safety.push({
      title: 'Emergency Evacuation Points',
      detail: site.evacuationPoints.replace('\n', '<br/>'),
      accepted,
    });
  }

  // first aid kits may be null
  if (site.firstAidKits) {
    site.safety.push({
      title: 'Location of First Aid Kits on Site',
      detail: site.firstAidKits,
      accepted,
    });
  }

  // medical centre should display last (just above the map)
  site.safety.push({ title: 'Nearest Medical Centre', detail: site.localMedicalCentre, accepted });

  return site;
};

const FieldMap = {
  ownerUsername: 'CONTRACT MANAGER',
  forepersonUsername: 'SITE CONTACT',
  firstAiders: 'First Aider\'s',
  emergencyWardens: 'Emergency Wardens',
};

const getFieldLabel = (field) => {
  if (Object.prototype.hasOwnProperty.call(FieldMap, field)) {
    return FieldMap[field];
  }

  return field;
};

const SectionTitles = {
  SITE_DETAILS: 'Site Details',
  CRITICAL_HAZARDS: 'Critical Hazards',
  ADDITIONAL_HAZARDS: 'Additional Hazards',
  GENERAL_HAZARDS: 'General Hazards',
  WORKSAFE_TASKS: 'WorkSafe Notifiable Tasks',
  MITIGATIONS_CONTROLS: 'Mitigations & Controls',
  PPE_REQUIREMENTS: 'PPE Requirements',
  SITE_SAFETY: 'Site Safety Information',
  PERSONAL_CONSENT: 'Personal Consent',
};

module.exports = {
  genericHazards,
  workSafeTasks,
  ppe,
  HAZARD_TYPE_CRITICAL,
  HAZARD_TYPE_STANDARD,
  HAZARD_TYPE_OTHER,
  mapHazards,
  formatSite,
  FieldMap,
  getFieldLabel,
  SectionTitles,
};
